<template>
  <div class="product">
    <ul>
        <li v-for="(item,index) in list" :key="index" @click="go(index)">
            <img :src="item" alt="">
        </li>
        <!-- <li>
            <img src="../assets/product02.png" alt="">
        </li>
        <li>
            <img src="../assets/product03.png" alt="">
        </li>
        <li>
            <img src="../assets/product04.png" alt="">
        </li>
        <li>
            <img src="../assets/product05.png" alt="">
        </li>
        <li>
            <img src="../assets/product06.png" alt="">
        </li>
        <li>
            <img src="../assets/product07.png" alt="">
        </li>
        <li>
            <img src="../assets/product08.png" alt="">
        </li>
        <li>
            <img src="../assets/product09.png" alt="">
        </li>
        <li>
            <img src="../assets/product010.png" alt="">
        </li>
        <li>
            <img src="../assets/product011.png" alt="">
        </li>
        <li>
            <img src="../assets/product012.png" alt="">
        </li> -->
    </ul>
  </div>
</template>

<script>
export default {
    data() {
        return {
            list:[
               require("../assets/img/wupin.png"),
               require("../assets/img/youpin.png"),
               require("../assets/img/gezi.png"),
               require("../assets/img/shengxian.png"),
               require("../assets/img/mini.png"),
               require("../assets/img/zhuban.png"),
            //    require("../assets/product02.png"),
            //    require("../assets/product03.png"),
            //    require("../assets/product04.png"),
            //    require("../assets/product05.png"),
            //    require("../assets/product06.png"),
            //    require("../assets/product07.png"),
            //    require("../assets/product08.png"),
            //    require("../assets/product09.png"),
            //    require("../assets/product010.png"),
            //    require("../assets/product011.png"),
            //    require("../assets/product012.png"),
            ]
        }
    },
    methods:{
        go(idx){
            this.$router.push({
                path:'/productDetal',
                query:{
                    idx:idx
                }
            })
        }
    }
}
</script>

<style scoped lang='less'>
.product{
    // background: pink;
    width: 1100px;
    margin: 30px auto;
    ul{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        li{
            width: 45%;
        }
    }
    img{
        width: 400px;
    }
}
</style>